import { Modal, Box, InputLabel, Select, MenuItem } from "@mui/material";
import closeIcon from "../../assets/icons/closeIcon.svg";
import { useEffect, useState } from "react";
import Spinner from "../../layouts/spinner/Spinner";
import addketInputFields from "./addketInputFields";

interface AddMasterKeyModalProps {
  openAddItemModal: boolean;
  loading?: boolean;
  title?: string;
  data?: any;
  handleCloseAddItemModal: () => void;
  handleSubmit: (e: any) => void;
}

const AddMasterKeyModal = ({
  openAddItemModal = false,
  handleCloseAddItemModal,
  handleSubmit,
  loading = false,
  title = "Add",
  data = false,
}: AddMasterKeyModalProps) => {
  const [inputFields, setInputFields] = useState<any>([]);
  const [addItemFormInput, setAddItemFormInput] = useState<any>({});

  useEffect(() => {
    let inputFiields: any = JSON.parse(JSON.stringify(addketInputFields));

    if (data) {
      for (let i = 0; i < inputFiields.length; i++) {
        inputFiields[i].value = data[inputFiields[i].name];
      }
    }
    setInputFields(inputFiields);
  }, [data]);

  const handleAddItemSubmit = (event: any) => {
    event.preventDefault();
    handleSubmit(addItemFormInput);
  };

  const handleAddItemInput = (val: any, fieldName: string, index: number) => {
    let addItemFormSData: any = addItemFormInput;
    addItemFormSData[fieldName] = val;
    setAddItemFormInput(addItemFormSData);

    let Data: any = [...inputFields];
    Data[index].value = val;
    setInputFields(Data);
  };

  const handleClose=()=>{
    setInputFields(addketInputFields);
    handleCloseAddItemModal();
  }
  return (
    <>
      <Modal
        open={openAddItemModal}
        onClose={handleClose}
        aria-labelledby="edit-modal-modal-title"
        aria-describedby="edit-modal-modal-description"
      >
        <Box className="modal-1-box">
          <div className="modal-1-header">
            <div className="modal-1-title">{title}</div>
            <div
              className="modal-1-close-btn-section"
              onClick={() => {
                handleClose();
              }}
            >
              <img src={closeIcon} className="icon-md" alt="" />
            </div>
          </div>
          <form onSubmit={handleAddItemSubmit}>
            <div className="model-1-form-body model-1-form-max-height">
              {inputFields?.map((item: any, index: number) => {
                return (
                  <>
                    {item.type === "text" && (
                      <div
                        className="input-div modal-1-input-div"
                        key={item.name}
                      >
                        <label
                          className="floating-label"
                          htmlFor="client-name-input"
                        >
                          {item.displayName}
                        </label>
                        <input
                          id="client-name-input"
                          className="input-field-1 "
                          required={!item.optional}
                          type="text"
                          value={item.value || ""}
                          onChange={(e) => {
                            handleAddItemInput(
                              e.target.value,
                              item.name,
                              index
                            );
                          }}
                        />
                      </div>
                    )}
                    {item.type === "dropdown" && (
                      <div
                        className="input-div modal-1-input-div"
                        key={item.name}
                      >
                        <InputLabel
                          id="demo-simple-select-helper-label"
                          className="floating-label"
                        >
                          {item.displayName}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="demo-simple-select-helper"
                          value={item.value || ""}
                          label="type"
                          required={!item.optional}
                          className="input-field-1 env-multiselect"
                          onChange={(e) => {
                            handleAddItemInput(
                              e.target.value,
                              item.name,
                              index
                            );
                          }}
                        >
                          {item?.options?.map((optionItem: any) => {
                            return(
                              <MenuItem value={optionItem.value}>{optionItem.label}</MenuItem>
                            )
                          })}
                        </Select>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
            <div className="model-1-form-actions center-div">
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn"
                onClick={() => {
                  handleCloseAddItemModal();
                }}
              >
                <div>Cancel</div>
              </button>
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                type="submit"
                disabled={loading}
              >
                <div>{loading ? <Spinner size="1rem" /> : <>Done</>} </div>
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default AddMasterKeyModal;
